export default "__VITE_PUBLIC_ASSET__dfd2b1f4__"